export const OTEL_SERVICE_NAME = 'nocowanie-frontend-app';
